import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Up: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowWall2Up"><Path fillRule="evenodd" clipRule="evenodd" d="M4 3H20V4.5H12.3106L17.3107 9.5L16.25 10.5607L12.75 7.06065V21H11.25V7.06067L7.75 10.5607L6.68934 9.5L11.6893 4.5H4V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWall2Up;
